import React from 'react';
import { DrawingBomProvider } from './DrawingBomContext';
import Main from './Main';

export default function DrawingBomTab({ initialDrawingId, autoDrawingId }) {
  return (
    <DrawingBomProvider initialDrawingId={initialDrawingId ?? autoDrawingId}>
      <Main autoDrawingId={autoDrawingId ?? initialDrawingId} />
    </DrawingBomProvider>
  );
}
